export * from "./format";
export * from "./fp";
export * from "./jsx";

export const siteUrl = process.env.BRANCH && process.env.BRANCH !== "master"
  ? process.env.DEPLOY_PRIME_URL
  : process.env.DEFAULT_HOST;

// data:image/svg;base64,iVBORw0KGgoAAAANS
export function parseDataUriToText(uri: string): string {
  const base64 = uri.split(",")[1];
  const ssr = typeof window === "undefined";
  if (ssr) {
    return Buffer.from(base64, "base64").toString();
  } else {
    return decodeURIComponent(escape(window.atob(base64)));
  }
}
